export const REDUCER_NAME = 'invoice'




// WEBPACK FOOTER //
// ./src/modules/invoice/state/const.js